// extracted by mini-css-extract-plugin
var _1 = "Video-module__container--Ai9sV";
export { _1 as "container" }
